export const categories = [
  { slug: 'japan-sakura', name: '日本樱花', icon: 'ri-earth-line', description: '日本各地绝美樱花名所实拍', count: 128 },
  { slug: 'china-sakura', name: '中国樱花', icon: 'ri-map-pin-line', description: '国内最美赏樱地合集', count: 96 },
  { slug: 'timelapse', name: '延时摄影', icon: 'ri-time-line', description: '樱花绽放绝美延时', count: 64 },
  { slug: 'travel-vlog', name: '旅行Vlog', icon: 'ri-camera-line', description: '跟着镜头去赏樱', count: 83 },
  { slug: 'viewing-guide', name: '赏樱攻略', icon: 'ri-book-open-line', description: '最佳时间与地点推荐', count: 47 },
];